export enum Permissions {
  VIEW_PRICING = 'marketplace.pricing.view',
  VIEW_COMMISSION = 'marketplace.commission.view',
}
